/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Analysis_Step3Inputs */

const en_gc_resources_guide_analysis_step3 = /** @type {(inputs: Gc_Resources_Guide_Analysis_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With the same source range, open the PivotTable command. Use Category as the row field and Amount as a value field, summarized by SUM.`)
};

const zh_gc_resources_guide_analysis_step3 = /** @type {(inputs: Gc_Resources_Guide_Analysis_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用相同数据区域打开数据透视表命令。将 Category 设为行字段，Amount 设为值字段，汇总方式选择 SUM。`)
};

/**
* | output |
* | --- |
* | "With the same source range, open the PivotTable command. Use Category as the row field and Amount as a value field, summarized by SUM." |
*
* @param {Gc_Resources_Guide_Analysis_Step3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_analysis_step3 = /** @type {((inputs?: Gc_Resources_Guide_Analysis_Step3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Analysis_Step3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_analysis_step3(inputs)
	return zh_gc_resources_guide_analysis_step3(inputs)
});
export { gc_resources_guide_analysis_step3 as "gc.resources.guide.analysis.step3" }